import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { DashboardSafeCard } from "./DashboardSafeCard";

const linkItemSx = {
    borderRadius: "12px",
    px: 1.5,
    py: 1.25,
    mx: -1.5,
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    background: "transparent",
    "&:hover": {
        background: "rgba(79, 70, 229, 0.05)",
        transform: "translateX(4px)",
        "& .link-icon": {
            color: "#4338ca",
            transform: "scale(1.12)",
        },
    },
};

const linkSx = {
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontWeight: 600,
    letterSpacing: "-0.01em",
    fontSize: "0.875rem",
    textDecoration: "none",
    color: "#4f46e5",
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        color: "#4338ca",
        textDecoration: "none",
    },
};

const linkDescSx = {
    color: "#78716c",
    ml: 3.5,
    fontSize: "0.8rem",
    lineHeight: 1.55,
    letterSpacing: "0.01em",
};

const chipSx = {
    borderColor: "rgba(99, 102, 241, 0.3)",
    borderRadius: "8px",
    fontWeight: 500,
    letterSpacing: "0.01em",
    backdropFilter: "blur(6px)",
    background: "rgba(79, 70, 229, 0.04)",
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        background: "rgba(79, 70, 229, 0.1)",
        borderColor: "rgba(99, 102, 241, 0.55)",
        transform: "scale(1.04)",
        cursor: "pointer",
    },
};

export default function DashboardSafeLinks() {
    return (
        <DashboardSafeCard
            icon={<LinkOutlinedIcon />}
            title="Liens utiles"
            accent="#4f46e5"
            accentSoft="rgba(79, 70, 229, 0.18)"
            footer={
                <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: "wrap" }}>
                    <Chip label="Site officiel" size="small" variant="outlined" sx={chipSx} component="a" href="https://www.groupe-vital.com/" target="_blank" rel="noreferrer" />
                </Stack>
            }
        >
            <Stack spacing={0.5}>
                <Box sx={linkItemSx}>
                    <Link
                        href="https://www.groupe-vital.com/"
                        underline="none"
                        sx={linkSx}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <InfoOutlinedIcon
                            className="link-icon"
                            fontSize="small"
                            sx={{ transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)" }}
                        />
                        Groupe Vital
                        <OpenInNewIcon fontSize="inherit" sx={{ ml: 0.25, opacity: 0.5 }} />
                    </Link>
                    <Typography variant="body2" sx={linkDescSx}>
                        Acceder au site officiel du Groupe Vital.
                    </Typography>
                </Box>
            </Stack>
        </DashboardSafeCard>
    );
}
